import './AssistantSkeleton.css';

export const AssistantSkeleton = () => (
  <article className="assistant-skeleton lis-card" aria-hidden="true">
    <div className="skeleton-block skeleton-photo" />
    <div className="assistant-skeleton-body">
      <div className="skeleton-block skeleton-line skeleton-line--title" />
      <div className="skeleton-block skeleton-line" />
      <div className="skeleton-block skeleton-line skeleton-line--short" />
    </div>
  </article>
);
